import { displayNumber } from 'utils/misc';

import { GridValueFormatterParams } from '@mui/x-data-grid-pro';

export const numberFormatter = (params: GridValueFormatterParams): string => {
  const { value } = params;
  if (!value) {
    return '';
  }
  return displayNumber(value);
};
